import ng from 'angular';
import { AuthContextService, GetEntryPointService } from '@/services';
import { LinkListItem } from '../../links/link-list/link-list';
import './panel-support.scss';
import { SupportFormData } from '@/atomic-components';

export class MoleculePanelSupportController implements ng.IController {
    public static $inject: string[] = ['authContext', 'getEntryPoint', '$translate'];

    public displayContent = false;
    public displaySupportModal: any = {
        contact: false,
        promise: false
    };
    public panelItemList: LinkListItem[];
    public skipAuthCheck = false; // for account activation netim -> hosting
    public supportFormDataOverwrite: SupportFormData;

    constructor(
        private authContext: AuthContextService,
        private getEntryPoint: GetEntryPointService,
        protected $translate: ng.translate.ITranslateService
    ) {}

    public $onInit() {
        this.displayContent = this.getEntryPoint.showSupportOptions;

        this.panelItemList = [
            {
                isGranted: true,
                onclickMethode: this.showSupportPromise,
                text: this.$translate.instant('TR_100119-c7dc72_TR')
            }, {
                isGranted: true,
                onclickMethode: this.showContactForm,
                text: this.$translate.instant('TR_100119-e49b56_TR')
            }
        ];
    }

    public showSupportPromise = () => {
        this.displaySupportModal.promise = true;
    };

    public showContactForm = () => {
        this.displaySupportModal.contact = true;
    };

    public showOnlyOnResellerAccounts = () => {
        return this.skipAuthCheck ? true : +this.authContext.account.parentAccountId <= 1000;
    };
}

export class MoleculePanelSupportComponent implements ng.IComponentOptions {
    public bindings = {
        skipAuthCheck: '<?',
        supportFormDataOverwrite: "<?",
    };
    public controller =  MoleculePanelSupportController;
    public template = require('./panel-support.html');
}
